import type { ReactNode } from 'react'
import React from 'react'
import { cm } from './utils'

interface Props {
  href: string
  children: ReactNode
  className?: string
  target?: string
}

export function Link({ href, children, className, target }: Props) {
  const link = href.replace('https//', '').replace('https://https://', 'https://')
  return (
    <a
      href={link}
      className={cm('text-[#65558f] hover:underline ml-1', className)}
      onClick={() => {
        if (target === '_blank') return
        location.href = link
      }}
      target={target}
    >
      {children}
    </a>
  )
}
